/**
 * Route prefixes that have no page of their own (row 42d67c26, Claire's link check 1 Nov): the
 * "Admin", "Marketing", "Organization" and "Motion" breadcrumbs on 16 pages linked to /admin,
 * /marketing, /organization and /motion, and every one opened "Page not found". A breadcrumb for
 * one of these is shown as text, not a link.
 *
 * Pinned against frontend/src/App.tsx by tests/test_42d67c26_a_breadcrumb_never_opens_page_not_found.py:
 * adding a route under a new section with no page of its own fails CI until it is listed here
 * (or the section gets a page). Ids in a path are written ":x".
 */
export const SECTIONS_WITHOUT_A_PAGE: ReadonlySet<string> = new Set([
  "/admin",
  "/answer",
  "/domains",
  "/domains/checkout",
  "/join",
  "/labs",
  "/marketing",
  "/meeting",
  "/meetings",
  "/motion",
  "/nda",
  "/nda/sign",
  "/organization",
  "/patents",
  "/retention-notices",
]);

const UUID_SEGMENT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Whether a breadcrumb's path opens a page (false for a section with no page of its own). */
export function crumbHasAPage(path: string): boolean {
  const pattern = "/" + path.split("/").filter(Boolean)
    .map((seg) => (UUID_SEGMENT.test(seg) ? ":x" : seg)).join("/");
  return !SECTIONS_WITHOUT_A_PAGE.has(pattern);
}
